import type { TeacherCourseAPIResponse } from 'app/types/modules';
import axios, { AxiosResponse } from 'axios';

/** `axios` ya prefija `/api/`, así que la ruta va sin barra inicial (igual que `TRAINING_V3`). */
export const TEACHER_COURSES_V3 = 'v3/front/teacher-courses';

type GetTeacherCoursesParams = {
  /**
   * Programa a excluir de la lista. El backend resuelve el `program_guid` de
   * cada curso según su tipo, así que el filtrado NO se repite en el front.
   */
  excludeProgramGuid: string;
};

type TeacherCoursesResponse = AxiosResponse<{ data: TeacherCourseAPIResponse[] }>;

/**
 * GET cursos del profesorado (programas licenciados + cursos de aula)
 * en una única lista plana. Backend TAN-10195: ya filtra borrados, cursos sin
 * acceso y sesiones académicas fuera de vigencia.
 */
export function getTeacherCourses({ excludeProgramGuid }: GetTeacherCoursesParams): Promise<TeacherCoursesResponse> {
  return axios.get(TEACHER_COURSES_V3, { params: { exclude_program: excludeProgramGuid } });
}
